import { findApplicant } from '@hc-frontend/business'
import { propAccessor } from '@hc-frontend/utils'
import {
  PPI_302_CENSUS_HEADLINE,
  PPI_302_CENSUS_HEADLINE_VARIANTS
} from 'core/constants/experiments'
import tooltip from 'core/DOM/tooltip'
import updateLocationCopies from 'core/DOM/updateLocationCopies'
import { getVariant } from 'core/experiment'
import getById from 'utils/DOM/getById'
import getURLParams from 'utils/DOM/getURLParams'
import innerHTML from 'utils/DOM/innerHTML'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import formInit from '../components/form/'
import { init as initController, initPhoneInput, updateFormData } from '../controller'
import registerSnowplowListeners from '../registerSnowplowListeners'
import showZipCode from '../showZipCode'
import './styles.scss'
import render from './view.pug'

const urlParams = getURLParams()

async function init({ hcStorage }) {
  initController(hcStorage)

  const referrer =
    document.referrer || propAccessor(window, 'opener.window.document.referrer', '')

  if (referrer && referrer.includes('/cobra-health-insurance')) {
    toggleClass('.generalHeader', 'd-none')
    toggleClass('.cobraHeader', 'd-none')
  }

  if (hcStorage.location.zip_code) {
    updateLocationCopies({ location: hcStorage.location })
  }
  const response = await updateFormData(hcStorage)
  if (!urlParams.zip || (response && response.data && response.data.length === 0)) {
    showZipCode()
  }

  const mainApplicant = findApplicant(hcStorage.members)
  if (mainApplicant) {
    initPhoneInput(mainApplicant.stringDOB)
  }
  formInit(hcStorage)

  if (urlParams.backTo) {
    innerHTML('.primaryButton', 'Update My Profile <i class="hc-icon-angle-right" />')
  }
  const years = hcStorage.policies
  textContent('.js-available-years', `${years} year${years > 1 ? 's' : ''}`)

  tooltip.init()
  registerSnowplowListeners()
}

export default {
  render,
  init,
  name: 'control'
}
